import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Hakkimizda = lazy(() => import('../pages/hakkimizda/page'));
const Iletisim = lazy(() => import('../pages/iletisim/page'));
const GizlilikPolitikasi = lazy(() => import('../pages/gizlilik-politikasi/page'));
const IadePolitikasi = lazy(() => import('../pages/iade-politikasi/page'));
const KargoBilgileri = lazy(() => import('../pages/kargo-bilgileri/page'));
const BankaHavalesi = lazy(() => import('../pages/banka-havalesi/page'));
const Magaza = lazy(() => import('../pages/magaza/page'));
const Kategoriler = lazy(() => import('../pages/kategoriler/page'));
const KategoriDetay = lazy(() => import('../pages/kategoriler/[slug]/page'));
const Urun = lazy(() => import('../pages/urun/page'));
const Sepet = lazy(() => import('../pages/sepet/page'));
const Odeme = lazy(() => import('../pages/odeme/page'));

// Admin Pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const AdminUrunler = lazy(() => import('../pages/admin/urunler/page'));
const AdminKategoriler = lazy(() => import('../pages/admin/kategoriler/page'));
const AdminSiparisler = lazy(() => import('../pages/admin/siparisler/page'));
const AdminSayfalar = lazy(() => import('../pages/admin/sayfalar/page'));
const AdminAyarlar = lazy(() => import('../pages/admin/ayarlar/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/hakkimizda',
    element: <Hakkimizda />,
  },
  {
    path: '/iletisim',
    element: <Iletisim />,
  },
  {
    path: '/gizlilik-politikasi',
    element: <GizlilikPolitikasi />,
  },
  {
    path: '/iade-politikasi',
    element: <IadePolitikasi />,
  },
  {
    path: '/kargo-bilgileri',
    element: <KargoBilgileri />,
  },
  {
    path: '/banka-havalesi',
    element: <BankaHavalesi />,
  },
  {
    path: '/magaza',
    element: <Magaza />,
  },
  {
    path: '/kategoriler',
    element: <Kategoriler />,
  },
  {
    path: '/kategoriler/:slug',
    element: <KategoriDetay />,
  },
  {
    path: '/urun/:id',
    element: <Urun />,
  },
  {
    path: '/sepet',
    element: <Sepet />,
  },
  {
    path: '/odeme',
    element: <Odeme />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/urunler',
    element: <AdminUrunler />,
  },
  {
    path: '/admin/kategoriler',
    element: <AdminKategoriler />,
  },
  {
    path: '/admin/siparisler',
    element: <AdminSiparisler />,
  },
  {
    path: '/admin/sayfalar',
    element: <AdminSayfalar />,
  },
  {
    path: '/admin/ayarlar',
    element: <AdminAyarlar />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
